// src/redux/classSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  get_accessmethod,
  add_accessmethod,
  update_accessmethod,
  delete_accessmethod,
  get_accessmethod_list
} from "../Service/ApiServices.js";
import { toast } from "react-toastify";

const initialState = {
  accessmethods: [],
  accessmethodlist:[],
  school_id: "",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name:"",
  },
  filterData: {
    school_class: "",
  },
};
// Async Thunks for API Calls
export const fetchaccessmethodlist = createAsyncThunk(
    'accessmethodtype/fetchaccessmethodlist',
    async ({school_id,token, signal }, { rejectWithValue }) => {
      try {
        const response = await get_accessmethod_list(school_id,token, signal);
        if (response.status) {
          return response.response;
        } else {
          return rejectWithValue(response.response.message);
        }
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
// Async Thunks for API Calls
export const fetchaccessmethod = createAsyncThunk(
  "accessmethod/fetchaccessmethod",
  async (
    { page, page_size, school_id,token, signal },
    { rejectWithValue }
  ) => {
    try {
      const response = await get_accessmethod(
        page,
        page_size,
        school_id,
        token,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createaccessmethod = createAsyncThunk(
  "accessmethod/createaccessmethod",
  async ({ data, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_accessmethod(data, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateaccessmethod = createAsyncThunk(
  "accessmethod/updateaccessmethod",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_accessmethod(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteaccessmethod = createAsyncThunk(
  "accessmethod/deleteaccessmethod",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_accessmethod({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// Class Slice
const accessmethodSlice = createSlice({
  name: "accessmethods",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    updateFilterData(state, action) {
        const { name, value } = action.payload;
        state.filterData[name] = value;
      },
    EditFormData(state, action) {
      // The action should contain all the fields that need to be updated
      const {
        id,
        name,
      } = action.payload;
      state.formData = {
        id,
        name,
      };
    },
    resetFormData(state) {
      state.formData = {
        name:"",
      };
    },
    setaccessmethod(state, action) {
      state.accessmethods = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchaccessmethodlist.fulfilled, (state, action) => {
        state.accessmethodlist = action.payload.data;
      })
      .addCase(fetchaccessmethodlist.rejected, (state, action) => {
        state.accessmethodlist = [];

      })
   
      // Fetch Classes
      .addCase(fetchaccessmethod.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchaccessmethod.fulfilled, (state, action) => {
        state.loading = false;
        state.accessmethods = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchaccessmethod.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add Class
      .addCase(createaccessmethod.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createaccessmethod.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createaccessmethod.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage);  
        state.IsEditing = false;
      })
      // Update Class
      .addCase(updateaccessmethod.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateaccessmethod.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateaccessmethod.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        state.IsEditing = false;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
      })
      // Delete Class
      .addCase(deleteaccessmethod.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteaccessmethod.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteaccessmethod.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  setaccessmethod,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize,
  updateFilterData,

} = accessmethodSlice.actions;
export default accessmethodSlice.reducer;
